"use strict";

const ConstructionProjectPopupGeoServerLayer = function () {
  var loadDomListeners = function ($popup) {
    $popup.off("click", ".project-popup-history-button");
    $popup.on("click", ".project-popup-history-button", inspectionHistoryButtonClick);

    $popup.off("click", ".project-popup-back-button");
    $popup.on("click", ".project-popup-back-button", clickOnBackButton);

    $popup.off("click", ".project-popup-photos");
    $popup.on("click", ".project-popup-photos", clickOnPhotosButton);

    $popup.off("click", ".project-popup-fact-sheet");
    $popup.on("click", ".project-popup-fact-sheet", openFactSheet);

    $popup.off("click", ".project-popup-delete-button");
    $popup.on("click", ".project-popup-delete-button", deleteConstructionProjectPopup);

    $popup.off("click", ".view-project-inventory");
    $popup.on("click", ".view-project-inventory", viewConstructionProjectInventory);

    $popup.off("click", "#construction-complete-project-btn");
    $popup.on("click", "#construction-complete-project-btn", openCompleteModal);

    $popup.off("click", ".download-inspection");
    $popup.on("click", ".download-inspection", ConstructionProjectPopup.downloadInspectionReport);

    $popup.off("click", ".show-enforcement-action-modal");
    $popup.on(
      "click",
      ".show-enforcement-action-modal",
      ConstructionProjectPopup.onEnforcementActionModalForInspection,
    );

    $popup.off("click", ".show-enforcement-action");
    $popup.on(
      "click",
      ".show-enforcement-action",
      ConstructionProjectPopup.showEnforcementActionModal,
    );

    $popup.off("click", ".post-active-button");
    $popup.on("click", ".post-active-button", ConstructionProjectPopup.showPostActiveModal);

    $popup.off("click", ".js-delete-construction-project-inspection");
    $popup.on("click", ".js-delete-construction-project-inspection", deleteProjectInspection);
  };

  var viewConstructionProjectInventory = function () {
    const id = $(this).parents(".popup-construction").data("id");
    ProjectInventoryModalController.invokeProjectInventoryModal(id);
  };

  var openCompleteModal = function (e) {
    const $row = $(e.currentTarget).closest("div");
    const id = $row.data("id");

    ProjectCompleteModal.renderAndShow(id);
  };

  var getPopupHtml = function (properties) {
    return PopupContent.getLayerPopup(properties, "constructionProjectG2");
  };

  var onPopupOpen = async function (properties) {
    const id = properties.id;
    var data = await getPopupData(id, properties);
    const html = getPopupHtml(data);
    const $popup = $(".leaflet-popup-content");
    $popup.html(html);
    loadDomListeners($popup);
    ConstructionProjectPopup._renderSiteVisitHistoryBarGraph(data?.siteVisitHistory);
    Tree.set(["layers", "constructionProject", "selectedId"], id);
    return PopupContent.getLayerPopup(data, "constructionProjectG2");
  };

  var deleteConstructionProjectPopup = function () {
    const popupCloseButn = $(".leaflet-popup-close-button");
    const data = $(this).closest(".popup-general").data();
    MessageModal.showThreeButtonConfirmWarningModal(
      `Delete Construction Project ${data.name} ? Click "Delete Project" to permanently delete the project and all associated inspections, photos and files. Click "Delete Project & Assets" to delete the project and all associated stormwater assets. Click "Cancel" to return.`,
      async function () {
        await ApiCalls.deleteProjectFactSheet(data.id);
        _closePopupAndReloadLayer(popupCloseButn);
      },
      async function () {
        await ApiCalls.deleteProjectFactSheet(data.id, true);
        _closePopupAndReloadLayer(popupCloseButn);
      },
      "Cancel",
      "Delete Project",
      "Delete Project & Assets",
    );
    Analytics.sendPopupEvent("delete_asset", "construction");
  };

  var getPopupData = async function (id) {
    const data = await ApiCalls.getProjectPopup(id);
    const constructionProps = await ConstructionProjectPopup.getConstructionPopupProps(data);
    constructionProps.groupId = data.groupId;
    return constructionProps;
  };

  var inspectionHistoryButtonClick = function () {
    var projectId = $(this).parents(".popup-general").data("id");
    _showInspectionHistory(projectId);

    Analytics.sendPopupEvent("view_historyTab", "construction");
  };

  var _showInspectionHistory = function (projectId) {
    ApiCalls.getConstructionProjectHistory(projectId, function (inspections) {
      $(".popup-construction-history").html(
        nunjucks.render("popups/constructionInspectionHistory.njk", {
          inspections,
        }),
      );
      $(".popup-main-pane").hide();
      $(".popup-history-button").hide();
      $(".popup-construction-history").show();
      $(".project-popup-back-button").show();
      $(".project-popup-delete-button").show();
      $(".project-popup-fact-sheet").hide();
    });
  };

  var clickOnPhotosButton = function () {
    const data = $(this).closest(".popup-general").data();

    PopupPhotos.load("constructionProject", data.id);
    $(".popup-main-pane").hide();
    $(".project-popup-back-button").show();
    $(".popup-photos-pane").show();
    $(".project-popup-fact-sheet").hide();

    Analytics.sendPopupEvent("view_photos", "construction");
  };

  var clickOnBackButton = function () {
    $(".popup-main-pane").show();
    $(".popup-history-pane").hide();
    $(".popup-photos-pane").hide();
    $(".project-popup-back-button").hide();
    $(".project-popup-delete-button").hide();
    $(".project-popup-fact-sheet").show();
  };

  var openFactSheet = function () {
    const dataView = Tree.get("dataView");
    if (dataView === "construction-project") {
      Analytics.sendPopupEvent("view_details", "construction");
    }
    const projectId = $(this).parents(".popup-construction").data("id");
    UrlRoutes.go("construction-project-fact-sheet", { id: projectId });
  };

  var _closePopupAndReloadLayer = function (popupCloseButn) {
    if (popupCloseButn.length) {
      popupCloseButn[0].click();
    }
    ConstructionProjectGeoServerLayer.invalidateLayerData();
    ConstructionProjectGeoServerLayer.loadLayer();
  };

  var deleteProjectInspection = function () {
    const inspectionId = ConstructionProjectPopup.getRowId($(this));
    MessageModal.showDeleteRecordModal(async function () {
      await ApiCalls.deleteConstructionProjectInspection(inspectionId);
      ConstructionProjectGeoServerLayer.invalidateLayerData();
    });
  };

  return {
    loadDomListeners,
    getPopupHtml,
    onPopupOpen,
    getPopupData,
    _showInspectionHistory,
  };
};

module.exports = ConstructionProjectPopupGeoServerLayer();

const ApiCalls = require("../apiCalls");
const PopupContent = require("../mapFunctions/popupContent");
const MessageModal = require("../modals/messageModal");
const Analytics = require("../general/analytics");
const PopupPhotos = require("../mapFunctions/popupPhotos");
const ConstructionProjectGeoServerLayer = require("../constructionG2/constructionProjectGeoServerLayer");
const ConstructionProjectPopup = require("../construction/constructionProjectPopup");
const Tree = require("../tree");
const ProjectInventoryModalController = require("../construction/projectInventoryModalController");
const ProjectCompleteModal = require("../construction/projectCompleteModal");
const UrlRoutes = require("../routes/urlRoutes");
